<template>
    <tailwind-layout title="Blogs">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto flex justify-between items-center">
                <h1 class="font-semibold text-2xl leading-tight">Create Blog Post</h1>
                <div class="flex items-center space-x-4">
                    <span class="isolate inline-flex rounded-md shadow-sm">
                        <inertia-link :href="route('blogs.index')"
                                      class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">
                            <font-awesome-icon :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
                        </inertia-link>
                    </span>
                </div>
            </div>
        </template>
        <div class="overflow-hidden shadow-xl rounded-lg p-6 bg-white">
            <form @submit.prevent="store">
                <div class="space-y-12">
                    <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div class="grid max-w-4xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div class="sm:col-span-full">
                                <label for="title" v-bind:class="(form.errors.category)?'block text-sm font-medium text-red-500 required-input':'block text-sm font-medium text-gray-700 required-input'">
                                    Title
                                </label>
                                <div class="mt-1">
                                    <input id="title" type="text" v-model="form.title" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                </div>
                                <p v-text="form.errors.title" class="text-red-500 text-sm"></p>
                            </div>
                            <div class="sm:col-span-full">
                                <label for="category" v-bind:class="(form.errors.blog_category_id)?'block text-sm font-medium text-red-500 required-input':'block text-sm font-medium text-gray-700 required-input'">
                                    Category
                                </label>
                                <div class="mt-1">
                                    <select id="category" name="category" v-model="form.blog_category_id" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
                                        <option value="">Choose category</option>
                                        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                                    </select>
                                </div>
                                <p v-text="form.errors.blog_category_id" class="text-red-500 text-sm"></p>
                            </div>
                            <div class="sm:col-span-full">
                                <label for="description" v-bind:class="(form.errors.description)?'block text-sm font-medium text-red-500 required-input':'block text-sm font-medium text-gray-700 required-input'">
                                    Description
                                </label>
                                <div class="mt-1">
                                    <TiptapEditor v-model="form.description" />
                                </div>
                                <p v-text="form.errors.description" class="text-red-500 text-sm"></p>
                            </div>
                            <div class="sm:col-span-full">
                                <label for="image" v-bind:class="(form.errors.image)?'block text-sm font-medium text-red-500 required-input':'block text-sm font-medium text-gray-700'">
                                    Image
                                </label>
                                <div class="mt-1">
                                    <input type="file" name="image" @input="form.image = $event.target.files[0]"/>
                                </div>
                                <p class="text-red-500 text-sm">Recommended 1000 X 1000 pixels minimum</p>
                                <p v-text="form.errors.image" class="text-red-500 text-sm"></p>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="pt-5">
                    <div class="flex justify-end">
                        <inertia-link :href="route('blogs.index')" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                        <form-button :form="form" class="ml-3">
                            Save
                        </form-button>
                    </div>
                </div>
            </form>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'
import TiptapEditor from '@/Shared/TiptapEditor.vue'

export default {
    props: {
        categories: Array,
    },
    components: {
        TailwindLayout,
        FormButton,
        FontAwesomeIcon,
        TiptapEditor
    },
    data() {
        return {
            form: this.$inertia.form({
                title: '',
                blog_category_id: '',
                description: '',
                image: null
            }),
            faChevronLeft,
        }
    },
    methods: {
        store() {
            this.form.post(this.route('blogs.store'))
        }
    }
}
</script>
